module.exports = __webpack_public_path__ + "static/media/classics-2-3.dbd436a2.jpg";